'use client';

import clsx from 'clsx';
import Lottie from 'lottie-react';

import artLottie from './lottie/art.json';
import atomLottie from './lottie/atom.json';
import ballLottie from './lottie/ball.json';
import lightbulbLottie from './lottie/lightbulb.json';
import mathLottie from './lottie/math.json';
import musicLottie from './lottie/music.json';
import planetLottie from './lottie/planet.json';
import scienceLottie from './lottie/science.json';
import techLottie from './lottie/tech.json';

import styles from './BackgroundSketchContainer.module.scss';

type BackgroundSketchContainerProps = {
  children: React.ReactNode;
  animated?: boolean;
};

export const BackgroundSketchContainer = ({ children, animated = false }: BackgroundSketchContainerProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.background}>
        <div className={clsx(styles.drawing, { [styles.animated]: animated })}>
          <Lottie animationData={planetLottie} className={clsx(styles.image, styles.planet)} autoplay={animated} />
          <Lottie animationData={atomLottie} className={clsx(styles.image, styles.atom)} autoplay={animated} />
          <Lottie
            animationData={lightbulbLottie}
            className={clsx(styles.image, styles.lightbulb)}
            autoplay={animated}
            initialSegment={animated ? undefined : [25, 25]}
          />
          <Lottie animationData={artLottie} className={clsx(styles.image, styles.art)} autoplay={animated} />
          <Lottie animationData={scienceLottie} className={clsx(styles.image, styles.science)} autoplay={animated} />
          <Lottie animationData={musicLottie} className={clsx(styles.image, styles.music)} autoplay={animated} />
          <Lottie
            animationData={techLottie}
            className={clsx(styles.image, styles.tech)}
            autoplay={animated}
            initialSegment={animated ? undefined : [50, 50]}
          />
          <Lottie animationData={ballLottie} className={clsx(styles.image, styles.ball)} autoplay={animated} />
          <Lottie
            animationData={mathLottie}
            className={clsx(styles.image, styles.math)}
            autoplay={animated}
            initialSegment={animated ? undefined : [25, 25]}
          />
        </div>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
